export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fa fa-dashboard",
      badge: {
        variant: "success",
        text: "NEW",
      },
    },
    {
      title: true,
      name: "Admin Panel",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Home",
      url: "/admin/home",
      icon: "fa fa-table",
    },
    {
      name: "Admin Panel",
      url: "/admin/panel/",
      icon: "fa fa-puzzle-piece",
      children: [
        {
          name: "usuarios",
          url: "/admin/panel/usuarios",
          icon: "fa fa-user",
        },
        {
          name: "Empresa",
          url: "/admin/panel/empresa",
          icon: "fa fa-building",
        },
        {
          name: "Departamentos",
          url: "/admin/panel/departamentos",
          icon: "fa fa-th-list",
        },
        {
          name: "Puestos",
          url: "/admin/panel/puestos",
          icon: "fa fa-briefcase",
        },
      ],
    },
    {
      name: "Admin RH",
      url: "/admin/rh/",
      icon: "fa fa-users",
      children: [
        {
          name: "incidencias",
          url: "/admin/rh/incidencias",
          icon: "fa fa-th-list",
        },
        {
          name: "turnos",
          url: "/admin/rh/turnos",
          icon: "fa fa-calendar",
        },
      ],
    },
    {
      name: "Personal",
      url: "/admin/personal/",
      icon: "fa fa-users",
      children: [
        {
          name: "listado personal",
          url: "/admin/personal/listado",
          icon: "fa fa-th-list",
        },
        {
          name: "Asignacion Horarios",
          url: "/admin/personal/asignacionHorarios",
          icon: "fa fa-calendar",
        },
        {
          name: "Asignacion Incidencias",
          url: "/admin/personal/asignacionIncidencias",
          icon: "fa fa-list",
        },
        {
          name: "Calendario",
          url: "/admin/personal/calendario",
          icon: "fa fa-calendar",
        },
      ],
    },
    /*
    {
      name: "Components",
      url: "/components",
      icon: "fa fa-puzzle-piece",
      children: [
        {
          name: "Buttons",
          url: "/components/buttons",
          icon: "fa fa-puzzle-piece",
          badge: {
            variant: "danger",
            text: "NEW",
          },
        },
        {
          name: "Badges",
          url: "/components/badges",
          icon: "fa fa-id-badge",
        },
        {
          name: "Alerts",
          url: "/components/alerts",
          icon: "fa fa-exclamation-triangle",
        },
        {
          name: "Progress Bars",
          url: "/components/progressbars",
          icon: "fa fa-spinner",
        },
        {
          name: "Grids",
          url: "/components/grids",
          icon: "fa fa-th",
        },
        {
          name: "Typography",
          url: "/components/typography",
          icon: "fa fa-file-word-o",
        },
      ],
    },
    {
      name: "Tables",
      url: "/components/tables",
      icon: "fa fa-table",
    },
    {
      name: "Forms",
      url: "/components/basic-form",
      icon: "fa fa-pencil-square-o",
      badge: {
        variant: "warning",
        text: "NEW",
      },
    },
    {
      name: "Chart JS",
      url: "/components/chartjs",
      icon: "fa fa-pie-chart",
      badge: {
        variant: "info",
        text: "NEW",
      },
    },
    {
      name: "Maps",
      url: "/components/maps/",
      icon: "fa fa-map-marker",
      badge: {
        variant: "info",
        text: "NEW",
      },
      children: [
        {
          name: "Google Maps",
          url: "/components/maps/google-maps",
          icon: "fa fa-map-o",
        },
        {
          name: "Leaflet Maps",
          url: "/components/maps/leaflet-maps",
          icon: "fa fa-street-view",
        },
      ],
    },
    {
      divider: true,
    },
    {
      title: true,
      name: "Extras",
    },
    {
      name: "Pages",
      url: "/auth",
      icon: "fa fa-paperclip",
      children: [
        {
          name: "Login",
          url: "/auth/login",
          icon: "fa fa-sign-in",
        },
        {
          name: "Register",
          url: "/auth/register",
          icon: "fa fa-sign-in",
        },
        {
          name: "Error 404",
          url: "/auth/Page404",
          icon: "fa fa-paper-plane",
        },
        {
          name: "Error 500",
          url: "/auth/Page500",
          icon: "fa fa-paper-plane",
        },
      ],
    },
    {
      name: "Documentation",
      url: "https://docs.vuejsadmin.com/docs/arbano-vue-js-admin/",
      icon: "fa fa-file-text-o",
      variant: "danger",
    },
    {
      name: "Free Download",
      url: "https://vuejsadmin.com/product/arbano/",
      icon: "fa fa-shopping-cart",
      class: "mt-auto",
      variant: "success",
    },
    {
      name: "Purchase PRO",
      url: "https://vuejsadmin.com/product/arbano-vuejs-admin-pro/",
      icon: "fa fa-shopping-cart",
      class: "mt-auto",
      variant: "success",
      badge: {
        variant: "danger",
        text: "HOT",
      },
    },*/
  ],
};
